window.addEventListener('DOMContentLoaded', function() {
    
    //////MOREボタン,ブログ記事を増やす//////
    //要素の数
    const listItems = document.querySelectorAll('.js-blog-more .staff-push__item');
    //MOREボタン
    const btnMore = document.querySelector('.js-btn-more');
    const btnWrapper = document.querySelector('.blog-prev-wrapper');
    //最初に表示させる数
    let num = 9;
    if (listItems.length > 0 && btnMore !== null) {
        // コードを実行する処理を記述
        if (num >= listItems.length) {
            btnMore.style.display = 'none';
        }
        
        // 最初に表示させるliの数
        for (let i = 0; i < listItems.length; i++) {
            // num以上はdisplay:none;
            if (i >= num) {
                listItems[i].style.display = 'none';
            }
        }
        
        //ボタンをクリックしたら
        btnMore.addEventListener('click', function() {
            // closeNum = num - 1;
            //追加する数
            num += 9;
            for (let i = 0; i < listItems.length; i++) {
                if (i < num) {
                    listItems[i].style.display = 'block';
                } else {
                    listItems[i].style.display = 'none';
                }
            }
            
            if (num >= listItems.length) {
                btnWrapper.style.display = 'none';
            }
        })
    } else if (btnMore !== null) {
        btnMore.style.display = 'none';
    }
})